import { app } from "modular-openscriptjs";
import { inform } from "./helpers";
import { Filter } from "./fotastart";
import { STRINGS } from "./declarations";
import { api, rPipeline } from "./declarations";
import { EchoEventListener } from "./classes/EchoEventListener";

app().singleton("EchoEventListener", EchoEventListener);

// base url was set in the _footer-scripts.blade
api.baseUrl = import.meta.env.VITE_API_BASE_URL || "/api/v1";

// add filters to the default Pipeline
rPipeline
	.add(
		new Filter(
			/**
			 * @param {Response} response
			 */
			async (response) => {
				let silentError = response.silent ?? false;

				try{
					let res = await response.json();
	
					if (response.ok) return Filter.output(res, true);
	
					if (response.status === 419) {
						response.silent = true;
						res.message = "An error occurred, please try again.";
					}
	
					if (!silentError) inform(res.message, STRINGS.ERROR);
				}
				catch (e) {
					if(e instanceof SyntaxError) return Filter.output(false, false);

					if (!silentError) inform("An error occurred", STRINGS.ERROR);
				}

				return Filter.output(false, false);
			}
		)
	)
	.add(
		new Filter(async (data) => {
			if (data.status === STRINGS.SUCCESS)
				return Filter.output(
					{ message: data.message, data: data.data },
					true
				);

			// show error message
			inform(data.message, STRINGS.ERROR);

			return Filter.output(false, false);
		})
	);

api.pipeline(rPipeline);
